import React, {Component} from 'react';
import {BrowserRouter, Route, Switch} from 'react-router-dom';

import Homepage from './Homepage';
import BreadCrumbs from './BreadCrumbs';

import '../styles/App.css';
import LanguageBar from './language/LanguageBar';

class App extends Component {

  render() {
      const languageCodes = ['de', 'fr', 'en', 'it'];
    return (
        <BrowserRouter>
            <div className='main-container'>
                <div  style={{marginBottom: 0}} className='row breadcrumbs valign-wrapper'>
                    <BreadCrumbs />
                    <LanguageBar 
                        languageCodes={languageCodes} 
                    />
                </div>
                <Switch>
                    <Route exact path='/configurator/:product/:product_id' component={Homepage}/>
                </Switch>
            </div>
        </BrowserRouter>
    );
  }

}

export default App;



// WEBPACK FOOTER //
// ./src/components/App.js